import BenchlingConfig from 'BenchlingConfig';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';
import APIUtil from 'util/APIUtil';

// Keep in sync with benchling/pipelines/steps/models/pipeline_step.py's update status
export const ANCESTOR_STEP_FAILED_ERROR_MESSAGE = 'Ancestor step is FAILED.';

export const PILL_DISABLED_DUE_TO_DOWNSTREAM_FLAG_ROWS = 'Cannot edit due to downstream flag rows step';
export const PUBLISHED_ANALYSIS_TEMPLATE_TOOLTIP_TEXT = 'Editing is disabled on published analysis templates';

/** Get tooltip message for an archived analysis or template. */
export function getArchivedTooltipMessage({id}: Pick<PipelineGraphQL, 'id'>): string {
  return APIUtil.isAnalysis(id)
    ? 'Editing is disabled on archived analyses'
    : 'Editing is disabled on archived analysis templates';
}

/** Get banner message for an archived analysis or template. */
export function getArchivedBannerMessage({id}: Pick<PipelineGraphQL, 'id'>, purpose: string): string {
  const noun = APIUtil.isAnalysis(id) ? 'analysis' : 'analysis template';
  return `This ${noun} is archived (${purpose}).`;
}

/** Get banner message for an analysis or template near its maximum number of steps. */
export function getStepLimitWarningText({id}: Pick<PipelineGraphQL, 'id'>, stepCount: number): string {
  const noun = APIUtil.isAnalysis(id) ? 'analysis' : 'analysis template';
  return `There is a limit of ${BenchlingConfig.PIPELINES_MAX_STEP_COUNT} steps for an ${noun}. This ${noun} currently has ${stepCount} steps.`;
}

/** Get tooltip message for a running analysis or template. */
export function getDisabledStillRunningMessage({id}: Pick<PipelineGraphQL, 'id'>): string {
  return APIUtil.isAnalysis(id) ? 'The analysis is still running' : 'The analysis template is still running';
}
